import { Component, ElementRef, inject, Input, OnInit, SkipSelf, TemplateRef, ViewChild } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { FormGroup } from '@angular/forms';
import { AgreementForm } from '../../../shared-agreement.model';
import { AgreementComponent } from 'app/features/agreement/pages/agreement/agreement.component';
@UntilDestroy()
@Component({
    selector: 'app-agreement-periods-renewals',
    templateUrl: './agreement-periods-renewals.component.html',
    styleUrl: './agreement-periods-renewals.component.scss'
})
export class AgreementPeriodsAndRenewalsComponent implements OnInit {
    @Input() public agreementForm: FormGroup<AgreementForm>;
    @Input() public showPotentialValidationMessages: boolean;

    @ViewChild('editModeFooterTemplate', { static: true })
    public readonly editModeFooterTemplate: TemplateRef<ElementRef>;

    @SkipSelf() private readonly agreementComponent = inject(AgreementComponent);

    public submitting: boolean;
    public get periodForm() {
        return this.agreementForm.controls.period;
    }

    public get reminderForm() {
        return this.agreementForm.controls.reminder;
    }

    public get fileForm() {
        return this.agreementForm.controls.fileUpload;
    }

    public ngOnInit() {
        this.agreementComponent.setFooterTemplate(this.editModeFooterTemplate);
    }

    public showReminder(): boolean {
        return this.periodForm.controls.commitmentPeriodTypeId.value >= 0;
    }

    public cancel() {
        this.agreementComponent.cancel();
    }

    public save() {
        this.agreementComponent.save();
    }
}
